let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cVwzB")).then(() => parcelRequire('ecO2s'));